//Replace widget-subtitle.component.ts

import { SWReactIcons } from "@similarweb/icons";
import { commonWebSources } from "app/components/filters-bar/utils";
import { MMXAlertWithPlainTooltip } from "app/components/MMXAlertWithPlainTooltip";
import { SWReactCountryIconsInline } from "app/components/React/SWReactIcons/SWReactCountryIconsInline";
import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { WidgetDashboardSubtitleV2 } from "app/dashboards/view-components/WidgetDashboardSubtitle-v2";
import * as _ from "lodash";
import type { FC } from "react";

export const WidgetSubtitleV2: FC<IDashboardWidgetInterface> = (props) => {
    const { widget } = props;
    const t = useTranslation();

    const showCountry = () => {
        return widget.viewOptions.showCountry === undefined ? true : widget.viewOptions.showCountry === true;
    };

    const getWebSourceIconName = () => commonWebSources[_.lowerFirst(widget.webSource)]().icon;
    const getWebSourceText = () => commonWebSources[_.lowerFirst(widget.webSource)]().text;

    if (!widget.dashboardId) {
        if (widget.viewOptions.showSubtitle && widget.widgetState == 2) {
            return (
                <div
                    className="swWidget-subTitle"
                    style={{
                        position: "relative",
                        top: "-7px",
                        display: "block",
                        marginTop: "-20px",
                        minHeight: "15px",
                        marginBottom: widget.viewOptions.subtitleMarginBottom || "0px",
                    }}
                >
                    {widget.subtitleData.country &&
                    !widget.subtitleData.category &&
                    !widget.viewOptions.hideMainSubtitle ? (
                        <div style={{ display: "flex", marginBottom: 5 }}>
                            {widget.viewData.duration &&
                            (widget.viewData.customSubtitle === "" || !widget.viewData.customSubtitle) ? (
                                <span>
                                    <SWReactIcons
                                        iconName="daily-ranking"
                                        className="first-icon-inline"
                                        size="xs"
                                    />
                                </span>
                            ) : null}
                            <span>{t(widget.viewData.customSubtitle || widget.viewData.duration)}</span>
                            {widget.viewOptions.showMmxMobileAlert ? (
                                <span>
                                    <MMXAlertWithPlainTooltip />
                                </span>
                            ) : null}
                            {showCountry() ? (
                                <span>
                                    <SWReactCountryIconsInline countryCode={widget.viewData.country.id} />
                                    <span title={widget.viewData.country.text}>{widget.viewData.country.text}</span>
                                </span>
                            ) : null}
                            {widget.viewOptions.showWebSource ? (
                                <span
                                    className="swWidget-subTitle-desktop-only"
                                    style={{ marginLeft: 8 }}
                                >
                                    <SWReactIcons
                                        iconName={getWebSourceIconName()}
                                        className="icon-inline"
                                        size="xs"
                                    />
                                    {t(getWebSourceText())}
                                </span>
                            ) : null}
                            {widget.viewOptions.desktopOnly ? (
                                <span className="swWidget-subTitle-desktop-only">
                                    <SWReactIcons
                                        iconName={"desktop"}
                                        className="icon-inline"
                                        size="xs"
                                    />
                                    {t(widget.subtitle.desktoponly)}
                                </span>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            );
        }

        return null;
    }

    return <WidgetDashboardSubtitleV2 widget={widget} />;
};
